import { EVENT_SERVICE_SOURCE } from '../../services/EventService/types';

export const FALLBACK_APPKEY = 'CHURCH';
export const RETRY_WAIT = 10; // minutes
export const CURRENT_EVENT_SOURCE = EVENT_SERVICE_SOURCE.TRACK_MEDIA_PROGRESS;
